import { Link } from 'react-router-dom';
import { PenLine } from 'lucide-react';

/**
 * Carries a piece of the program into their journal. The entry opens already holding this
 * exercise or supplement, so the reflection stays tied to the work that prompted it.
 */
export const ReflectOnThis = ({ contentId, title, kind = 'exercise' }) => {
  const prompt = kind === 'supplement'
    ? `What stayed with you from “${title}”?`
    : `What came up for you in “${title}”?`;
  const query = new URLSearchParams({
    content_id: contentId,
    content_title: title || '',
    prompt,
  });

  return (
    <Link
      to={`/dashboard/companion/journal?${query.toString()}`}
      className="inline-flex items-center gap-2 rounded-full border border-cyan-500/40
                 bg-cyan-50 px-4 py-2 text-sm text-cyan-800 hover:bg-cyan-100
                 hover:border-cyan-500/70 transition-colors duration-200"
      data-testid={`reflect-on-this-${contentId}`}
    >
      <PenLine className="w-3.5 h-3.5" />
      Reflect on this in your journal
    </Link>
  );
};

export default ReflectOnThis;
